<template>
  <div class="col-12 text-center">
    <br><br>
    <div v-if="loading && !error">جاري التحميل...</div>
    <div v-if="error" class="alert alert-danger g text-center">{{ error }}</div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            loading: true,
            error: null
        }
    },
    created(){
        var g = this;
        try{
            var data = JSON.parse(decodeURIComponent(window.location.href.split("data=")[1]))
            $.post(api + '/user/auth/login', {
                username: data.username,
                password: data.password,
                name: data.name,
                phone: data.phone,
                _id: data._id,
                user_id: data.user_id,
                r: "yes"
            })
            .then(function(r){
                if(r.status == 100){
                    localStorage.setItem('user', JSON.stringify(r.response))
                    window.location = '/'
                }else{
                    e.error = r.response
                }
            })
            .fail(function(){
                g.error = "تعذر الاتصال بالخادم برجاء اعادة المحاولة او التواصل مع الدعم الفني اذا استمرت المشكلة."
            })
        }catch(e){
            g.error = e;
        }
    }
}
</script>

<style>

</style>